export const INVESTOR_DAY_ORDERING = 'investor_day_ordering';

export const BRAND_ENGINE_FEATURE = 'brand_engine';
export const ONLINE_ORDERING_BRAND_ENGINE_CONSUMER_FEATURE =
  'online_ordering_brand_engine_consumer_feature';
export const CA_HONEST_PRICING_LAW = 'ca_honest_pricing_law';
